const selector = {
    passwordVisibility: '#passwordVisibility',
    password: '#password',
};

export {selector};